module.exports = __webpack_public_path__ + "static/media/sr_home2.072a17d7.svg";